import { useMediaQuery } from '@mui/material';

import { forDesktop, forMobile, forPhone, forTablet } from '@/styles/responsive';
import { useCustomTheme } from '@/styles/theme';

export const useIsPhone = (): boolean => {
  const theme = useCustomTheme();

  return useMediaQuery(forPhone(theme));
};

export const useIsMobile = (): boolean => {
  const theme = useCustomTheme();
  const isMobile = useMediaQuery(forMobile(theme));

  return isMobile;
};

export const useIsTablet = (): boolean => {
  const theme = useCustomTheme();
  const isTablet = useMediaQuery(forTablet(theme));

  return isTablet;
};

export const useIsDesktop = (): boolean => {
  const theme = useCustomTheme();
  const isDesktop = useMediaQuery(forDesktop(theme));

  return isDesktop;
};
